<template lang="pug">
  //-統一跟一般課程、隨選隨上、百家書苑API回傳格式
  div
    server-time-clock(ref="servertime")
    p.txt-enter-classroom-hint *進教室時間為前5分鐘至後3分鐘內
    phone-help
    br
    transition(name="fade" mode="out-in")
      div(v-if="classroomList.length > 0" key="classroomList")
        .reg-classroom
          transition-group(name="fade")
            div(v-for="classroomData in classroomList" :key="classroomData.class_applications")
              vip-classroom(:show_consultant_img='true' :classroom_type="'normal'" :classroomData="classroomData")
        vip-week-class-count
        b-pagination(v-model="currentPage" :total-rows="classroomPaination.last_page" :per-page="1" align="center")
      div(v-else key="empty")
        .reg-no-booking
          span.mt-3(v-html="$t('classroom.no_class_message')")
</template>

<script type="text/javascript">
import classroomConstant from '@/constants/classroom';
import ServerTimeClock from '@/components/serverTimeClock';
import PhoneHelp from '@/components/common/phoneHelp';
import VipClassroom from '@/components/class/vipClassroom';
import VipWeekClassCount from '@/components/class/vipWeekClassCount';
// import LioshutanApi from '@/api';
import { legacyClassrooms } from '@/api/lib/legacyApi';

export default {
  name: 'EnterClassroom',

  components: {
    ServerTimeClock,
    PhoneHelp,
    VipClassroom,
    VipWeekClassCount,
  },

  data() {
    return {
      currentPage: 1, // 第1頁起始
      classroomList: {},
      classroomPaination: {},
      cloudClassRoomTimer: '',
      serverTimeClock: null,
    };
  },

  watch: {
    currentPage(next) {
      if (next !== this.classroomPaination.current_page) {
        this.getCurrentClass();
      }
    },

  },

  created() {
    this.getCurrentClass();
    this.cloudClassRoomTimer = setInterval(this.autoRefresh, 60000);
    // this.reCallCloudClassroom();
    // this.autoRefresh();
    // setInterval(autoRefresh, 60000);
  },

  beforeDestroy() {
    // clearTimeout(this.cloudClassRoomTimer);
    clearInterval(this.cloudClassRoomTimer);
    if (this._handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this._handleVisibilityChange);
    }
  },
  mounted() {
    // 背景恢復偵測 - App 從背景回到前景時立即刷新（含 2 秒防抖）
    this._lastResumeTime = 0;
    this._handleVisibilityChange = async() => {
      if (!document.hidden) {
        const now = Date.now();
        if (now - this._lastResumeTime < 2000) {
          return;
        }
        this._lastResumeTime = now;

        console.log('[AutoRefresh] Resumed from background, refreshing...');
        await this.getCurrentClass();
      }
    };
    document.addEventListener('visibilitychange', this._handleVisibilityChange);
    // 當 ServerTimeClock 組件掛載後，可以訪問其內部內容
    // if (this.serverTimeClock) {
    //   // 獲取 serverTime 的值（假設 serverTime 是組件內的數據）
    //   console.log(this.serverTimeClock.serverTime);

    //   // 獲取 txt-system-time 的 HTML 元素
    //   const txtSystemTime = this.serverTimeClock.$el.querySelector('.txt-system-time');
    //   if (txtSystemTime) {
    //     console.log(txtSystemTime.textContent);
    //   }
    // }
    // console.log(this.$refs.servertime.$el.querySelector('.txt-system-time').textContent);
    const myDiv = this.$refs.servertime.$el.querySelector('.txt-system-time');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') {
          // console.log('DOM 內容變化了:', mutation.target.textContent);
          this.serverTimeClock = mutation.target.textContent;
        }
      });
    });
    observer.observe(myDiv, {
      characterData: true,
      subtree: true,
    });
  },
  methods: {
    async getCurrentClass() {
      // 只顯示當日可上課教室 cts: 當日 00:00:00, cte: 當日 23:59:59
      const params = {
        searchType: classroomConstant.FILTER_STATUS.CLOUD_CLASSROOM,
        page: this.currentPage,
      };
      // 目前直接使用api資料夾回傳 response.data 資料
      // const res = await LioshutanApi.classroom.getClassroom(params);
      // this.classroomList = res.data;
      // this.classroomPaination = res.meta.pagination;
      const legacyofres = await legacyClassrooms(params);
      const vipParent = legacyofres.data.data.vip_parent || [];
      this.classroomList = legacyofres.data.data.data.map(item => ({
        ...item,
        vip_parent: vipParent,
      }));
      const { current_page, from, last_page, next_page_url, per_page, prev_page_url, to } = legacyofres.data.data;
      const pagination = {
        current_page,
        from,
        last_page,
        next_page_url,
        per_page,
        prev_page_url,
        to,
      };
      this.classroomPaination = pagination;
    },
    // reCallCloudClassroom(){
    //   this.cloudClassRoomTimer = setTimeout(() => {
    //     this.getCurrentClass();
    //     this.reCallCloudClassroom();
    //   }, classroomConstant.CLOUD_TABLE.REFRESH_TIME);
    // },
    async autoRefresh() {
      const now = new Date(this.serverTimeClock);
      const minutes = now.getMinutes();

      if (minutes === 4 || minutes === 25 || minutes === 34 || minutes === 55) {
        this.getCurrentClass();
        // this.reCallCloudClassroom();
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/class/classroom';
@import '@/styles/transition';

.txt-enter-classroom-hint {
  color: #ff0000;
  font-size: 1.1rem;
  text-align: center;
}
</style>
